import { FetchLookupsResponse } from '@lib/api';
import { logger } from '@lib/logger';

import { LookupsValue } from '../types';

export function getFirestoreOrderQueryFromLookupsResponse(
  lookupsResponse: FetchLookupsResponse,
): LookupsValue['query'] {
  // branch uuids take advantage over restaurant and group
  if (lookupsResponse.branchesUuids?.length) {
    if (lookupsResponse.branchesUuids?.length > 30) {
      logger.error('Received more than 30 branch ids');
    }

    return [
      'orderMessage.ref.branch.uuid',
      'in',
      lookupsResponse.branchesUuids.slice(0, 30),
      // '02080a81-2e66-42c1-9025-889398dd42db',
    ];
  }

  if (lookupsResponse.restaurants.length) {
    if (lookupsResponse.restaurants?.length > 30) {
      logger.error('Received more than 30 restaurants ids');
    }

    return [
      'orderMessage.ref.restaurant.uuid',
      'in',
      lookupsResponse.restaurants.slice(0, 30).map((r) => r.restaurantUUID),
      // '36661745-2224-11e8-924e-0242ac110011',
    ];
  }

  if (lookupsResponse.group?.groupUUID) {
    return [
      'orderMessage.ref.groupUUID',
      '==',
      lookupsResponse.group?.groupUUID,
      // '03330977-a813-46d2-905e-76fbceb12656',
    ];
  }

  return ['trace.uuid', '==', 'none']; // a query that will never return any results
}
